import managerExpenseGroup from './managerExpenseGroup';
import accountantGroup from './accountantGroup';
import managerAdvanceGroup from './managerAdvanceGroup';
import employeeAdvanceGroup from './employeeAdvanceGroup';
import employeeExpenseGroup from './employeeExpenseGroup';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [accountantGroup, managerExpenseGroup, managerAdvanceGroup, employeeAdvanceGroup, employeeExpenseGroup]
};

export default menuItems;
